import { FieldError } from '@/components/Form/fields';

import ToggleBadge from './ToggleBadge';
import { useAIVisibilitySettingsForm } from './useAIVisibilitySettingsForm';

type CompetitorProductAreasProps = {
  competitorIndex: number;
};

const CompetitorProductAreas = ({ competitorIndex }: CompetitorProductAreasProps) => {
  const form = useAIVisibilitySettingsForm();

  return (
    <form.Subscribe selector={(state) => state.values.brandProductAreas}>
      {(brandProductAreas) => (
        <form.Subscribe selector={(state) => state.isSubmitting}>
          {(isSubmitting) => (
            <form.AppField
              name={`competitors[${competitorIndex}].comparedProductAreas`}
              mode="array"
            >
              {(comparedProductAreasField) => {
                const selectedProductAreas = comparedProductAreasField.state.value;
                const errors = comparedProductAreasField.state.meta.errors;
                const isInvalid = errors.length > 0;

                return (
                  <>
                    <div className="mt-3 flex flex-wrap items-center gap-2">
                      {brandProductAreas.map((name) => {
                        const isPressed = selectedProductAreas.includes(name);

                        return (
                          <ToggleBadge
                            key={name}
                            className={isPressed ? undefined : 'border-gray-400 bg-white'}
                            pressed={isPressed}
                            disabled={isSubmitting}
                            onPressedChange={(nextPressed) => {
                              if (nextPressed) {
                                comparedProductAreasField.pushValue(name);
                                return;
                              }

                              const selectedIndex = selectedProductAreas.indexOf(name);
                              if (selectedIndex >= 0) {
                                comparedProductAreasField.removeValue(selectedIndex);
                              }
                            }}
                          >
                            {name}
                          </ToggleBadge>
                        );
                      })}
                    </div>
                    {isInvalid && <FieldError className="mt-2" errors={errors} />}
                  </>
                );
              }}
            </form.AppField>
          )}
        </form.Subscribe>
      )}
    </form.Subscribe>
  );
};

export default CompetitorProductAreas;
